import React from 'react';

import HandyPageWrapper from '~Scenes/Handy/Components/HandyPageWrapper';
import { useI18n } from '~Hooks';
import POSLayoutSelection from './PosLayoutSelection';

const PosLayout = () => {
  const { i18n } = useI18n();

  return (
    <HandyPageWrapper pageTitle={i18n('Handy.Settings.PosLayoutTitle')}>
      <POSLayoutSelection />
    </HandyPageWrapper>
  );
};

export default PosLayout;
